// @ts-ignore
import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-hipastatus',
  templateUrl: './hipastatus.page.html',
  styleUrls: ['./hipastatus.page.scss'],
})
export class HipastatusPage {
  // declare variables
  public date: any;
  public assets = environment.assets;
  public status_url = environment.hipainfo;
  public status_url2 = environment.hipastatus;
  public display: any;
  public refreshIcon = false;

  //constructor
  constructor() {
    this.display = 'info'
  }

  // refreshes the status image
  public doRefresh() {
    this.refreshIcon = true;
    // gets timestamp
    this.date = Date.now();
    setTimeout(() => {
      this.status_url = environment.hipainfo + this.date;
      this.status_url2 = environment.hipastatus + this.date;
      this.refreshIcon = false;
    }, 2000);
  }
}
